import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    selector: 'details-page-header',
    templateUrl: './index.html',
    styleUrls: ['./style.scss'],
})
export class DetailsPageHeaderComponent {
    constructor(
        private location: Location,
    ) {}

    @Input() content: string;
    @Input() defaultBack: string;
    @Input() editRoute?: string;

    back() {
        this.location.back()
    }
}
